export class UIRoomWarningPopupContentBase {
    constructor(roomState){
        this.roomState = roomState;
    }
}
